module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "left-sidebar"
    }
  }, [_c('ul', {
    staticClass: "left-nav-list list-unstyled"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('router-link', {
      key: "menu" + index,
      attrs: {
        "to": item.alink,
        "tag": "li",
        "active-class": "active-link"
      }
    }, [_c('img', {
      class: item.icon,
      attrs: {
        "src": '/static/img/dashboard/' + item.icon + '.svg',
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ef15466!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/leftSidebar/IndexMain.vue
// module id = 1304
// module chunks = 1